import InputField from "../../ui/InputField/InputField";
import classes from "../BasicInfo/BasicInfo.module.css";

const carCategories = [
  "Sedan",
  "SUV",
  "Hatchback",
  "Coupe",
  "Convertible",
  "Pickup Truck",
  "Minivan",
  "Van",
  "Crossover",
  "Wagon",
];

const carTypes = [
  "Luxury",
  "Economy",
  "Compact",
  "Standard",
  "Full-size",
  "Premium",
  "Sport",
  "Off-road",
  "Electric",
  "Hybrid",
];

const tierOptions = ["Standard", "Premium"];

const transmissionTypes = ["Automatic", "Manual"];

const fuelTypes = ["Petrol", "Diesel", "Hybrid", "Electric"];

const Specifications = ({ formData, updateFormData }) => {
  const handleChange = (e) => {
    updateFormData({ [e.target.name]: e.target.value });
  };

  return (
    <div className={classes.form}>
      <h4>Car specifications</h4>
      <div className={classes.group}>
        <InputField
          labelText="Category"
          name="category"
          value={formData.category}
          options={carCategories}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Type"
          name="type"
          value={formData.type}
          options={carTypes}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Tier"
          name="tier"
          value={formData.tier}
          options={tierOptions}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Transmission"
          name="transmission"
          value={formData.transmission}
          options={transmissionTypes}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Fuel type"
          name="fuelType"
          value={formData.fuelType}
          options={fuelTypes}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Number of seats"
          placeholder="Eg. 2025"
          name="numberOfSeats"
          type="number"
          value={formData.numberOfSeats}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Engine size"
          name="engineSize"
          placeholder="Eg. 2.5"
          value={formData.engineSize}
          required
          onChange={handleChange}
        />
      </div>
      <div className={classes.group}>
        <InputField
          labelText="Current mileage"
          name="mileage"
          placeholder="Enter mileage"
          value={formData.mileage}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default Specifications;
